import { jsx as _jsx } from "react/jsx-runtime";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useCallback, useMemo } from "react";
import { Button } from "sprout-ui-dom";
import { ArrowBackIosOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import Dialog from "../Dialog";
import AssignmentDialogInner from "./AssignmentDialogInner";
import processAndMarkWorkspaceMembers from "./processAndMarkWorkspaceMembers";
const AssignmentDialog = (props)=>{
    const { open , onRequestClose , workspaceMembers , selectedItems  } = props;
    const handleClose = useCallback(()=>{
        onRequestClose(new Error("Closing `AssignmentDialog`"));
    }, [
        onRequestClose
    ]);
    const currentUser = useCurrentUser();
    const downshiftUsers = useMemo(()=>{
        return processAndMarkWorkspaceMembers(workspaceMembers, selectedItems).sort((_, b)=>{
            if (b.user.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return 1;
            return -1;
        });
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        selectedItems,
        workspaceMembers
    ]);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        hideContextualActionBar: "desktop",
        contextualTitle: "Assign to",
        onRequestClose: handleClose,
        leftAction: /*#__PURE__*/ _jsx(Button, {
            variant: "circle-bright-blue-bg",
            color: "white.100",
            onClick: handleClose,
            children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
        }),
        children: /*#__PURE__*/ _jsx(Flex, {
            minHeight: "0",
            flexDirection: "column",
            px: 1,
            children: /*#__PURE__*/ _jsx(AssignmentDialogInner, {
                onRequestClose: onRequestClose,
                users: downshiftUsers,
                selectedItems: selectedItems
            })
        })
    });
};
export default AssignmentDialog;
